import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f81476"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "add-event-modal" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "heading-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "line1" }, "View event"),
  /*#__PURE__*/_createElementVNode("span", { class: "line2" }, "Time entry")
], -1))
const _hoisted_3 = { class: "body-main" }
const _hoisted_4 = { class: "event-form" }
const _hoisted_5 = { class: "ls-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Type", -1))
const _hoisted_7 = {
  key: 0,
  class: "ls-form"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigator", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Activity", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigation", -1))
const _hoisted_11 = {
  key: 1,
  class: "row mt-4 mb-1"
}
const _hoisted_12 = { class: "colone" }
const _hoisted_13 = { class: "info-wrapper" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Branch", -1))
const _hoisted_15 = { class: "fielddata" }
const _hoisted_16 = { class: "info-wrapper" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Address", -1))
const _hoisted_18 = { class: "fielddata" }
const _hoisted_19 = { class: "coltwo" }
const _hoisted_20 = { class: "info-wrapper" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Business phone", -1))
const _hoisted_22 = { class: "fielddata" }
const _hoisted_23 = { class: "info-wrapper" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Email", -1))
const _hoisted_25 = { class: "fielddata" }
const _hoisted_26 = { class: "info-wrapper" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fieldname" }, "Investigation type", -1))
const _hoisted_28 = { class: "fielddata" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "colone mr-1" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Date", -1))
const _hoisted_32 = { class: "coltwo" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start time", -1))
const _hoisted_34 = { class: "input" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End time", -1))
const _hoisted_36 = { class: "input" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Break duration (in min)", -1))
const _hoisted_38 = { class: "input-box" }
const _hoisted_39 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_41 = {
  key: 1,
  class: "validation-msg"
}
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_44 = {
  key: 1,
  class: "ls-form"
}
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Investigator", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Leave Type", -1))
const _hoisted_47 = {
  key: 0,
  class: "validation-msg"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-circle" }, null, -1))
const _hoisted_49 = { class: "datetime-wrapper" }
const _hoisted_50 = { class: "date-wrapper" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start date", -1))
const _hoisted_52 = { class: "time-wrapper" }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Start time", -1))
const _hoisted_54 = { class: "datetime-wrapper" }
const _hoisted_55 = { class: "date-wrapper" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End date", -1))
const _hoisted_57 = { class: "time-wrapper" }
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "End time", -1))
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Notes", -1))
const _hoisted_60 = { class: "controls mt-4" }
const _hoisted_61 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_LoadingIndicator = _resolveComponent("LoadingIndicator")
  const _component_ErrorIndicator = _resolveComponent("ErrorIndicator")
  const _component_ModalBox = _resolveComponent("ModalBox")

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_ModalBox, {
      onClose: _cache[1] || (_cache[1] = $event => (_ctx.closeModal()))
    }, {
      "header-text": _withCtx(() => [
        _hoisted_2
      ]),
      body: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.loadingDataSet)
              ? (_openBlock(), _createBlock(_component_LoadingIndicator, { key: 0 }))
              : (_ctx.errorLoadingDataSet)
                ? (_openBlock(), _createBlock(_component_ErrorIndicator, { key: 1 }))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createElementVNode("form", _hoisted_5, [
                      _createElementVNode("fieldset", null, [
                        _hoisted_6,
                        _createTextVNode(" " + _toDisplayString(_ctx.formData.eventTypeId == 1 ? 'Time entry' : 'Leave') + " ", 1)
                      ])
                    ]),
                    (_ctx.formData.eventTypeId == 1)
                      ? (_openBlock(), _createElementBlock("form", _hoisted_7, [
                          _createElementVNode("fieldset", null, [
                            _hoisted_8,
                            _createTextVNode(" " + _toDisplayString(_ctx.formData.investigation?.trustTeamMember?.displayName) + " ", 1),
                            _hoisted_9,
                            _createTextVNode(_toDisplayString(_ctx.formData.activityType?.name) + " ", 1),
                            (_ctx.formData.activityType?.isInvestigation)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _hoisted_10,
                                  _createElementVNode("div", null, _toDisplayString(_ctx.formData.investigation?.latestPracticeLogData?.firmName), 1)
                                ], 64))
                              : _createCommentVNode("", true),
                            (_ctx.formData.investigation?.id > 0)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                      _hoisted_14,
                                      _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.selectedInvestigation.latestPracticeLogData?.firmId), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_16, [
                                      _hoisted_17,
                                      _createElementVNode("span", _hoisted_18, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.selectedInvestigation.latestPracticeLogData?.branchAddress), 1)
                                      ])
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_19, [
                                    _createElementVNode("div", _hoisted_20, [
                                      _hoisted_21,
                                      _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.selectedInvestigation.latestPracticeLogData?.businessPhone ?? ''), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_23, [
                                      _hoisted_24,
                                      _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectedInvestigation.latestPracticeLogData?.email ?? ''), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_26, [
                                      _hoisted_27,
                                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.selectedInvestigation.investigationType?.name), 1)
                                    ])
                                  ])
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_29, [
                              _createElementVNode("div", _hoisted_30, [
                                _hoisted_31,
                                _createTextVNode(" " + _toDisplayString(_ctx.startDate ? _ctx.startDate.toLocaleDateString('en-GB') : '') + " ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_32, [
                                _hoisted_33,
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.convertToAMPM(_ctx.startTime)) + " ", 1),
                                _hoisted_35,
                                _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.convertToAMPM(_ctx.endTime)) + " ", 1)
                              ])
                            ]),
                            _hoisted_37,
                            _createElementVNode("div", _hoisted_38, [
                              _createTextVNode(_toDisplayString(_ctx.formData.breakDuration) + " ", 1),
                              (_ctx.formData.breakDuration == null || isNaN(_ctx.formData.breakDuration))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                    _hoisted_40,
                                    _createTextVNode(" Mandatory field ")
                                  ]))
                                : _createCommentVNode("", true),
                              (!_ctx.validBreakDuration && _ctx.formData.breakDuration)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    _hoisted_42,
                                    _createTextVNode(" Break duration is larger than the work duration ")
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _hoisted_43,
                            _createElementVNode("div", null, _toDisplayString(_ctx.formData.notes), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.formData.eventTypeId == 2)
                      ? (_openBlock(), _createElementBlock("form", _hoisted_44, [
                          _createElementVNode("fieldset", null, [
                            _hoisted_45,
                            _createTextVNode(" " + _toDisplayString(_ctx.formData.trustTeamMember?.displayName) + " ", 1),
                            _hoisted_46,
                            _createElementVNode("div", null, _toDisplayString(_ctx.getLeaveTypeName(_ctx.formData.leaveTypeId)), 1),
                            (!_ctx.formData.leaveTypeId)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                  _hoisted_48,
                                  _createTextVNode(" Mandatory field ")
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_49, [
                              _createElementVNode("div", _hoisted_50, [
                                _hoisted_51,
                                _createTextVNode(" " + _toDisplayString(_ctx.startDate ? _ctx.startDate.toLocaleDateString('en-GB') : '') + " ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_52, [
                                _hoisted_53,
                                _createTextVNode(" " + _toDisplayString(_ctx.convertToAMPM(_ctx.startTime)) + " ", 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_54, [
                              _createElementVNode("div", _hoisted_55, [
                                _hoisted_56,
                                _createTextVNode(" " + _toDisplayString(_ctx.endDate ? _ctx.endDate.toLocaleDateString('en-GB') : '') + " ", 1)
                              ]),
                              _createElementVNode("div", _hoisted_57, [
                                _hoisted_58,
                                _createElementVNode("div", null, _toDisplayString(_ctx.convertToAMPM(_ctx.endTime)), 1)
                              ])
                            ]),
                            _hoisted_59,
                            _createElementVNode("div", null, _toDisplayString(_ctx.formData.notes), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_60, [
                      _createElementVNode("button", {
                        class: "btn btn-default",
                        disabled: _ctx.submitting,
                        onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.closeModal()), ["prevent","stop"]))
                      }, " Back ", 8, _hoisted_61)
                    ])
                  ], 64))
          ])
        ])
      ]),
      _: 1
    })
  ]))
}